import {
  purple,
  bronze,
  silver,
  pink,
  green,
  red,
  blue,
} from "assets/votes-level";
import america from "assets/play/america.png";
import eye from "assets/play/eye.png";
import inviteFriend from "assets/play/invite-friend.png";
import leaderboard from "assets/play/leaderboard.png";
import luckyBox from "assets/play/lucky-box.png";
import mission from "assets/play/missions.png";
import profile from "assets/play/profile.png";
import status from "assets/play/statue.png";
import vector from "assets/play/Vector.png";
import voteBox from "assets/play/vote-box.png";
import { Modal } from "components/Modal";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AppState, useAppDispatch } from "reducers";
import { updateVote } from "reducers/auth.reducer";
import { ROUTES } from "routes/config";
import { doVote } from "services/apis/auth";
import { convertNumber, copyClipboard, generateInviteLink } from "utils";

import { useWebApp } from "@vkruglikov/react-telegram-web-app";

import "./index.scss";

interface HeaderComponentProps {
  title: string;
  headerImage: React.ReactNode;
  onClick?: () => void;
}

const HeaderComponent = ({
  title,
  headerImage,
  onClick = () => {},
}: HeaderComponentProps) => {
  return (
    <>
      <div
        className="flex flex-col h-full justify-end items-center gap-[5px] cursor-pointer"
        onClick={onClick}
      >
        {headerImage}
        <div className="text-white/50 text-[9px] font-[Roboto] font-semibold">
          {title}
        </div>
      </div>
    </>
  );
};

export function Play() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state: AppState) => state.auth);
  const [isInviteFriend, setIsInviteFriend] = useState(false);

  const onVote = async () => {
    const currentTime = new Date();
    const today =
      currentTime.getFullYear() +
      "-" +
      (currentTime.getMonth() + 1) +
      "-" +
      currentTime.getDate();
    const _res = await doVote({ time: today });

    dispatch(
      updateVote({
        limit: _res.level.limit,
        from: _res.level.from,
        to: _res.level.to,
        amount: _res.user.amount,
        votedAmount: _res.level.votedAmount,
        level: _res.user.level,
      })
    );
  };

  const Headers = [
    {
      title: "Lucky box",
      img: <img src={luckyBox} className="w-[35px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.comingSoon),
    },
    {
      title: "America",
      img: <img src={america} className="w-[60px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.comingSoon),
    },
    {
      title: "Eye",
      img: <img src={eye} className="w-[35px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.comingSoon),
    },
    {
      title: "Profile",
      img: <img src={profile} className="w-[30px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.comingSoon),
    },
  ];

  const footers = [
    {
      title: "Statue",
      img: <img src={status} className="w-[30px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.mining),
    },
    {
      title: "Invite friend",
      img: <img src={inviteFriend} className="w-[52px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.invite),
    },
    {
      title: "Leaderboard",
      img: <img src={leaderboard} className="w-[40px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.comingSoon),
    },
    {
      title: "Missions",
      img: <img src={mission} className="w-[52px] h-auto" alt="" />,
      onClick: () => navigate(ROUTES.comingSoon),
    },
  ];

  const VoteAvatar = () => {
    switch (user.level) {
      case 1:
        return <img src={bronze} className="w-[164px] h-[164px]" alt="" />;
      case 2:
        return <img src={pink} className="w-[164px] h-[164px]" alt="" />;
      case 3:
        return <img src={red} className="w-[164px] h-[164px]" alt="" />;
      case 4:
        return <img src={green} className="w-[164px] h-[164px]" alt="" />;
      case 5:
        return <img src={blue} className="w-[164px] h-[164px]" alt="" />;
      case 6:
        return <img src={purple} className="w-[164px] h-[164px]" alt="" />;
      case 7:
        return <img src={silver} className="w-[164px] h-[164px]" alt="" />;
      default:
        return <img src={bronze} className="w-[164px] h-[164px]" alt="" />;
    }
  };

  return (
    <>
      <div className="play-container">
        <div className="play-header">
          <div className="play-items flex justify-between gap-[15px]">
            {Headers.map((header, index) => (
              <HeaderComponent
                title={header.title}
                headerImage={header.img}
                key={index}
                onClick={header.onClick}
              />
            ))}
          </div>

          <div className="play-progress">
            <div className="flex justify-between">
              <div className="text-white text-[12px] font-semibold font-[Roboto]">
                Electoral
              </div>
              <div className="text-white text-[12px] font-semibold font-[Roboto]">
                {`+${user.amount - user.from}`}
              </div>
            </div>

            <div className="play-electoral">
              <div
                className="h-full relative"
                style={{
                  width: `${
                    user.amount > user.from
                      ? ((user.amount - user.from) / (user.to - user.from)) *
                        100
                      : 0
                  }%`,
                }}
              >
                <div className="h-full w-full relative slideProgress " />
              </div>
            </div>
          </div>
        </div>

        <div className="play-body flex flex-col gap-[15px]">
          <div className="flex gap-[10px] items-center justify-center">
            <label className="text-[#FFFEFD] text-[32px] font-[Roboto] font-bold">
              {convertNumber(user.amount)}
            </label>
          </div>
          <button
            className="active:animate-customBounce text-center flex justify-center"
            onClick={onVote}
          >
            {VoteAvatar()}
          </button>
        </div>

        <div className="play-bottom">
          <div className="play-status">
            <img src={vector} className="w-[16px] h-auto" alt="" />
            <span className="text-white text-[11px] font-[Roboto] font-semibold">
              {`${user.votedAmount} / ${user.limit}`}
            </span>
          </div>
          <div className="play-items flex justify-between gap-[10px] h-[80px]">
            {footers.map((footer, index) => (
              <HeaderComponent
                title={footer.title}
                headerImage={footer.img}
                key={index}
                onClick={footer?.onClick}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
